<template>
	<div id="report_form">
		<div class='report_form_left'>
			<div class='title'>
				报告列表
			</div>
			<div class='report_form_left_content'>
				 <el-tabs v-model="activeName" @tab-click="handleClick" :stretch='true'>
				    <el-tab-pane v-for='item in tabList' :label="item.name" :name="item.message" :key='item.name'>
				    	<el-select v-model="value" filterable placeholder="请选择"  size='small' style='width: 3.4rem;margin-top: .3rem;' v-show='item.message == "first"'>
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						</el-select>
						<div>
							<ul class='BG_list' v-loading='loading'  element-loading-background="rgba(36,49,69,.5)" v-if='reportList.length'>
								<li v-for='i in reportList'>
									<div class="BG_list_item_left" @click='handleClick_preview(i)' :class='i.id==nowClickID?"active_BG_list":""'>
										{{i.fileName}}
									</div>
									<div class="BG_list_item_right">
										<span>
											<img src="/static/v12houtai/shoucang_active.png" alt="收藏" v-if='i.isCollect==1' @click='iconClick("collect",i)'>
											<img src="/static/v12houtai/shoucang.png" alt="收藏" v-else @click='iconClick("notCollect",i)'>
										</span>
										<span v-if='false'>
											<img src="/static/v12houtai/fenxiang_active.png" alt="分享" v-if='i.isShare == 1' @click='iconClick("share",i)'>
											<img src="/static/v12houtai/fenxiang.png" alt="分享" v-else @click='iconClick("notShare",i)'>
										</span>
									</div>
								</li>
								
							</ul>
							<div v-else class='notReport'>暂无报告</div >
						</div>
				    </el-tab-pane>
				  </el-tabs>
				  <i class='el-icon-search' @click='vagueSearch'></i>
			</div>
		</div>
		<div class='report_form_right'>
			<!-- <div class='title'>
				{{nowTitle}}
			</div> -->
			<div class='operation'>
				<span @click='handleClick_download'>
					<span class='img_container'>
						<img src="/static/v12houtai/xiazai.png" alt="下载文档">
					</span>
					下载文档
				</span>
				<span @click='getCollectReportInfo_z'>
					<span class='img_container'>
						<img src="/static/v12houtai/shoucang_active.png" alt="收藏" v-if='isCollect'>
						<img src="/static/v12houtai/shoucang.png" alt="收藏" v-else>
					</span>
					收藏
				</span>
				<span v-if='false'>
					<span class='img_container'>
						<img src="/static/v12houtai/fenxiang_active.png" alt="分享" v-if='isShare' @click='iconClick("share","")'>
						<img src="/static/v12houtai/fenxiang.png" alt="分享" v-else @click='getshareReportInfo("")'>
					</span>
					分享
				</span>
			</div>
			<div class='content'>
				<!-- <iframe :src="'../../static/pdf/web/viewer.html?file='+nowRequestURL" width="100%" height="1000px" id='myframe' v-if='nowRequestURL!=""'>
				</iframe> -->
				<img src="/static/v12houtai/noReport.png" alt="打印区域" class='noReport'>
				
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			super_messages:Boolean
		},
		data() {
			return {
				nowRequestURL: '',   // 当前请求pdf地址
				isOperationNow: true,   // 是否操作当前行
				isFirst:true,        // 请求一次
				isCollect: false,    // 当前报告是否收藏
				isShare: false,    // 当前报告是否分享
				nowClickID: '',      // 当前点击ID
				nowTitle: '',  // 现在选中名字
				nowType:"",   // 现在选中
				loading: false,         // 加载
				 activeName: 'first',
				 reportList: [],  // 报告列表
				 tabList: [
				 	{name: '报告',type:"",message:'first'},
				 	{name: '收藏',type:"1",message:'second'},
				 	// {name: '分享',type:"2",message:'third'},
				 ],
				 options: [{
			          value: '选项1',
			          label: '所有报告'
			        }],
			        value: '选项1',
			     reportName: '', // 检索名字
			}
		},
		created() {
			this.getReportList();
		},
		mounted() {
			
		},
		methods: {
			// 点击模糊搜索
			vagueSearch() {
				  this.$prompt('请输入报表名称', '搜索', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		        }).then(({ value }) => {
		        	this.reportName = value;
		        	this.getReportList();
		        }).catch(() => {
		                
		        });
			},
			// 报告下载
			handleClick_download() {

				if(!this.nowClickFilePath) {
					return this.$message.warning('未检测到报告！')
				}
				let cid=sessionStorage.getItem('cid');
			  	let token=sessionStorage.getItem('token');
			  	let label_a = document.createElement('a');
			  	label_a.href = "https://files.mankoo.cn/"+this.nowClickFilePath;
			  	label_a.download  = this.nowClickFilePath;
 				label_a.click();
			},
			// 详细页收藏
			getCollectReportInfo_z(type) {


				let num,_ = this,params;
				params={
		    		reportName:'',
		    		type:''
		    	}
				try {
					// 查询所有报告
					_.$http.post('reportDesk/findReport',params).then(res=>{
						if(res&&res.data.code==1) {
							if(res.data.data.length) {
								res.data.data.forEach(item=>{
									if(_.nowClickID == item.id) {
										num = item.isCollect==1?"2":"1";
										this.getCollectReportInfo(this.nowClickID,num);
									}
								})
							}
						}
					})
				}catch(e) {
				}
				
			},
			// 点击报告预览
			handleClick_preview(row) {
				let _ = this;
				let cid=sessionStorage.getItem('cid');
				let token=sessionStorage.getItem('token');
				_.nowTitle = row.fileName;
				_.nowClickID = row.id;
				_.nowClickFilePath = row.filePath;
				if(_.reportList.length) {
					_.reportList.forEach(item=>{
						if(_.nowClickID == item.id) {
							_.isCollect = item.isCollect==1?true:false;
							_.isShare = item.isShare==1?true:false;
						}
					})
				}
				 _.nowRequestURL = encodeURIComponent("https://files.mankoo.cn/"+row.filePath);
				
			},
			// 分享、收藏点击
			iconClick(type,row) {
				 switch(type) {
		        	case "collect":
		        		this.getCollectReportInfo(row.id,"2");
		        		break;
		        	case "notCollect":
		        		this.getCollectReportInfo(row.id,"1");
		        		break;
		        	case "share":
		        		return this.$message({
								type:'warning',
								message:"您已经分享过了哟！"
							});
		        		break;
		        	case "notShare":
		        		this.getshareReportInfo(row.id);
		        		break;
		        	default:
		        		return;
		        		break;
		        }
		        // isOperationNow
			},
			// 点击切换
			handleClick(tab, event) {
				this.reportName = '';
		        switch(tab.label) {
		        	case "报告":
		        		this.nowType = '';
		        		this.getReportList();
		        		break;
		        	case "收藏":
		        		this.nowType = '1';
		        		this.getReportList();
		        		break;
		        	case "分享":
		        		this.nowType = '2';
		        		this.getReportList();
		        		break;
		        	default:
		        		this.nowType = '';
		        		this.getReportList();
		        		break;
		        }
		    },
		    // 查询报告/
		    getReportList() {
		    	let _=this,params;
		    	params={
		    		reportName:_.reportName,
		    		type:_.nowType
		    	}
				try {
					_.$emit('super_messages_back',false);
					_.loading = true;
					_.$http.post('reportDesk/findReport',params).then(res=>{
						if(res&&res.data.code==1) {
							_.reportList = res.data.data;
							_.loading = false;
							
							if(res.data.data.length) {
								if(_.isFirst) {
									_.isFirst =false;
									let cid=sessionStorage.getItem('cid');
								  	let token=sessionStorage.getItem('token');
									_.nowClickID = res.data.data[0].id;
									_.nowClickFilePath = res.data.data[0].filePath;
									 _.nowRequestURL = encodeURIComponent("https://files.mankoo.cn/"+res.data.data[0].filePath);
									document.getElementById("myframe").scrolling="no";
									_.nowTitle = res.data.data[0].fileName;
									
								}
								_.reportList.forEach(item=>{
									if(_.nowClickID == item.id) {
										_.isCollect = item.isCollect==1?true:false;
										_.isShare = item.isShare==1?true:false;
									}
								})
							}else {
								 _.nowRequestURL='';
							}
							
							
						}else {
							_.loading = false;
						}
					})
				}catch(e) {
					_.loading = false;
				}
		    },

		    // 收藏/
		    getCollectReportInfo(id,type) {
		    	let _=this,params;
		    	params={
		    		id:id,
		    		type:type
		    	}
				try {
					_.$http.post('reportDesk/collectReport',params).then(res=>{
						if(res&&res.data.code==1) {
							this.getReportList();
							this.$message({
								type:'success',
								message:res.data.msg
							});
						}
					})
				}catch(e) {

				}
		    },
		     // 分享
		    getshareReportInfo(id) {
		    	let _=this,params;
		    	id=id?id:_.nowClickID;
		    	params={
		    		id:id,
		    	}
				try {
					_.$http.post('reportDesk/shareReport',params).then(res=>{
						if(res&&res.data.code==1) {
							this.getReportList();
							this.$message({
								type:'success',
								message:res.data.msg
							});
							
						}
					})
				}catch(e) {

				}
		    },
		},
		watch: {
			super_messages(val) {
				this.isFirst = true;
				this.getReportList();

			}
		}
	}
</script>
<style lang='less'>
	#report_form {
		display: flex;
		justify-content: space-between;
		height: 100%;
		width: 100%;
		position: relative;
		iframe{
			height: 100% !important;
			display: inline-block;
			border: none;
			overflow-y: visible;
			border-radius: 5px;
		}
		#viewer {
			background: #fff;
		}
		.page {
			margin:0 !important;
		}
		#viewerContainer{
			overflow: visible !important;
		}
		.report_form_left {
			position: fixed;
			width: 4rem;
			height: 100%;
			background: #243145;
			border-radius: 5px;
			padding: .3rem .3rem 0;
			box-sizing: border-box;
			.title {
				font-size: .3rem;
				color: #fff;
			}
			.report_form_left_content {
				margin-top: .4rem;
				position: relative;
				.el-input__inner {
					background-color: #243145;
					border-color: #374964;
				}
				.el-tabs {
					.el-tabs__nav.is-stretch{
						width: 2.04rem;
						min-width: 0rem;
					}
					.el-tabs__item {
						color:#8FBEFF;
						font-size: .14rem;
						padding: 0 .3rem;
					}
					.el-tabs__item.is-top:nth-child(2){
						padding-left: 0 !important;
					}
					.el-tabs__item.is-top:last-child {
						padding-right: 0 !important;
					}

					#tab-second {
					}
					.is-active {
						color:#FFFFFF;
					}
					.el-tabs__nav-wrap::after {
						display: none;
					}
				}
				.el-icon-search {
					color: #FFFFFF;
					font-size: .22rem;
					cursor: pointer;
					position: absolute;
					top: .1rem;
					right: 0;
				}
				.BG_list {
					.active_BG_list {
						color:#107EF2 !important;
					}
					li {
						display: flex;
						justify-content: space-between;
						margin-top: .3rem;
						width: 100%;
						.BG_list_item_left {
							cursor: pointer;
							color: #fff;
							&:hover {
								color: #ddd;
							};
						}
						.BG_list_item_right {
							span {
								width: .22rem;
								display: inline-block;
								cursor: pointer;
								img {
									width: 100%;
								}
								&:last-child{
									margin-left: .5rem;
								};
							}
						}
						&:not(:first-child){
							margin-top: .3rem;
						};

					}
					
				}
				.notReport {
					color:#999;
					font-size: .16rem;
					text-align: center;
					margin-top: .2rem;
				}
			}
		}
		.report_form_right {
			position: fixed;
			width: 12.9rem;
			height: 100%;
			right:.3rem;
			padding: .3rem .25rem;
			box-sizing: border-box;
			background: #243145;
			border-radius: 5px;
			/*.title {
				font-size: .3rem;
				color:#fff;
				text-align: center;
			}*/
			.operation {
				text-align: right;
				padding: .0rem 0 .2rem;
				span {
					display: inline-block;
					color: #fff;
					cursor: pointer;
					&:hover{
						color: #ddd;
					};
					&:not(:first-child){
						margin-left: .4rem;
					};
	
				}
				.img_container {
					width: .22rem;
					display: inline-block;
					margin-right: .1rem;
					img {
						width: 100%;
					}
				}
			}
			.content {
				width: 100%;
				height: 100%;
				background: #F5F5F5;
				display: inline-block;
				border-radius:5px;
				text-align: center;
				min-height: 5rem;
				margin-top: .1rem;
				color:#6F6F6F;
				font-size: .3rem;
				text-align: center;
				&>span {
					width: 100%;
				}
				.noReport {
					display: inline-block;
					margin-top: 2.5rem;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/report_form.vue